import React from "react";
import WeatherTemp from "./WeatherTemp";

export default function WeatherInfo(props) {
  return (
    <div className="WeatherInfo">
      <div>
        <img className="weather-icon icon" alt="" src={props.data.icon_url} />
      </div>
      <div className="city-name">{props.data.city}</div>
      <div className="weather-desc-1">
        <ul>
          <li>
            <span className="day">{props.data.day} </span>
            <span className="date">{props.data.fullDate}</span>
          </li>
          <li className="temperature">
            <WeatherTemp celsius={props.data.temp} />
          </li>
          <li className="desc text-capitalize last-li">{props.data.desc}</li>
        </ul>
      </div>
      <div className="weather-desc-2">
        <ul>
          <li>Pressure: {props.data.pressure}hPa</li>
          <li>Humidity: {props.data.humidity}%</li>
          <li className="last-li">Wind: {props.data.wind}km/h</li>
        </ul>
      </div>
    </div>
  );
}
